import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import Loading from '@/components/Core/Loading'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'

export default {
  name: 'Service',
  components: {
    Loading
  },
  metaInfo () {
    let title = this.categoryName + '管理 | ' + Constants.SiteInfo.title
    this.setMeta({ title: title })
    return this.getMeta
  },
  data () {
    return {
      loading: true,
      registerHash: Constants.RegisterHash,
      
      // テーブルオプション
      tableColumns: [
        'serviceId',
        'serviceName',
        'serviceTypes',
        'communityName',
        'tenantName',
        'serviceStatus',
        'detailButton'
      ],
      tableData: [],
      tableOptions: {
        headings: {
          serviceId: 'サービスID',
          serviceName: 'サービス名',
          serviceTypes: 'サービスタイプ',
          communityName: 'コミュニティ名',
          tenantName: 'テナント名',
          serviceStatus: 'ステータス',
          detailButton: ''
        },
        columnsClasses: {
          serviceId: 'wp-5',
          serviceName: '',
          serviceTypes: '',
          communityName: '',
          tenantName: '',
          serviceStatus: '',
          detailButton: 'wp-5 has-button'
        },
        sortable: [
          'serviceId',
          'serviceName',
          'serviceTypes',
          'communityName',
          'tenantName',
          'serviceStatus'
        ],
        filterable: [],
        texts: Constants.TableOptions.getTexts(this.categoryName),
        // perPage: Constants.TableOptions.perPage.view,
        perPage: Constants.TablePerPageInitial,
        perPageValues: Constants.TableOptions.perPageValues,
        pagination: Constants.TableOptions.pagination
      },

      // // 検索
      // searchServiceId: null,
      // searchServiceName: null,
      // searchServiceType: '',
      // searchStatus: '',
      // searchTenant: '',
      // searchCommunity: '',

      // 絞込み
      activeFilters: false,
      filterPerPage: Constants.TablePerPageInitial
    }
  },
  mounted () {
    this.$set(this.tableOptions, 'texts', Constants.TableOptions.getTexts(this.categoryName))

    this.init()
  },
  beforeDestroy() {
    if (this.$route.name !== 'ServiceDetail') {
      this.reset()
    }
  },
  computed: {
    ...mapState({
      categoryName: state => state.service.categoryName,

      // model
      serviceModel: state => state.service.serviceModel,
      serviceTypeModel: state => state.service.serviceTypeModel,
      tenantModel: state => state.service.tenantModel,
      communityModel: state => state.service.communityModel,

      // 検索
      filters: state => state.service.filters,
    }),
    ...mapGetters({
      getMeta: 'meta/get',
      permittedView: 'permission/permittedView',
      isSmartPhone: 'core/isSmartPhone'
    }),

    // search
    serviceTypeList () {
      return this.serviceTypeModel.map(item => {
        return {
          value: item.serviceTypeCd,
          label: item.serviceTypeName
        }
      })
    },
    statusList () {
      return Constants.Status.sort(Utility.sortByKey('index', true))
    },
    tenantList () {
      return this.tenantModel.map(item => {
        return {
          value: item.tenant.tenantUuid,
          label: item.tenant.name
        }
      })
    },
    communityList () {
      return this.communityModel.map(item => {
        return {
          value: item.communityUuid,
          label: item.name
        }
      })
    },

    // list
    tablePerPageList () {
      let list = []
      Constants.TablePerPage.forEach(item => list.push({
        value: item,
        label: item
      }))
      return list
    },
    showFilters () {
      return !this.isSmartPhone ||
        this.activeFilters
    },

    // filter
    searchServiceId: {
      get () {
        return this.filters.searchServiceId
      },
      set (value) {
        this.setInputFilter({
          key: 'searchServiceId',
          value: value
        })
      }
    },
    searchServiceName: {
      get () {
        return this.filters.searchServiceName
      },
      set (value) {
        this.setInputFilter({
          key: 'searchServiceName',
          value: value
        })
      }
    },
    searchServiceType: {
      get () {
        return this.filters.searchServiceType
      },
      set (value) {
        this.setInputFilter({
          key: 'searchServiceType',
          value: value
        })
      }
    },
    searchStatus: {
      get () {
        return this.filters.searchStatus
      },
      set (value) {
        this.setInputFilter({
          key: 'searchStatus',
          value: value
        })
      }
    },
    searchTenant: {
      get () {
        return this.filters.searchTenant
      },
      set (value) {
        this.setInputFilter({
          key: 'searchTenant',
          value: value
        })
      }
    },
    searchCommunity: {
      get () {
        return this.filters.searchCommunity
      },
      set (value) {
        this.setInputFilter({
          key: 'searchCommunity',
          value: value
        })
      }
    },
  },
  methods: {
    ...mapActions({
      setMeta: 'meta/set',
      showError: 'error/show',
      loadModel: 'service/loadModel',
      loadServiceList: 'service/loadServiceList',
      reset: 'service/reset'
    }),
    ...mapMutations({
      setInputFilter: 'service/setInputFilter',
    }),

    init () {
      this.loading = true

      //
      let serviceParams = { filters: {} }
      if (this.searchServiceId)
        serviceParams.filters.serviceId = this.searchServiceId
      if (this.searchServiceName)
        serviceParams.filters.serviceName = this.searchServiceName
      if (this.searchServiceType !== '')
        serviceParams.filters.serviceTypeKbn = this.searchServiceType
      if (this.searchStatus !== '')
        serviceParams.filters.serviceStatus = this.searchStatus
      if (this.searchTenant !== '')
        serviceParams.filters.tenantUuid = this.searchTenant
      if (this.searchCommunity !== '')
        serviceParams.filters.communityUuid = this.searchCommunity
      console.log('search.parameters', serviceParams)

      // データ読出し
      this.loadModel({
        serviceParams: serviceParams
      })
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
          this.tableData = $.extend(true, [], this.serviceModel)
        })
        .catch(error => {
          this.showError(error || null)
          // // エラーメッセージ表示
          // if (error) {
          //   this.showError(error)
          // // アプリケーションエラー表示
          // } else {
          //   this.showError(null)
          // }
        })
    },
    getViewData (props) {
      let key = props.column
      let value = props.row[key]

      switch (key) {
        case 'serviceTypes':
          return value.length ? value.join('、') : ''
        case 'serviceStatus':
          return Utility.getConstantsLabel(['Status'], value)
      }
      return value
    },
    changePage () {
      // console.log(this.$refs.table.page)
    },

    // 検索
    resetSearch () {
      this.searchServiceId = null
      this.searchServiceName = null
      this.searchServiceType = ''
      this.searchStatus = ''
      this.searchTenant = ''
      this.searchCommunity = ''

      this.init()
    },
    search () {
      this.loading = true

      //
      let serviceParams = { filters: {} }
      if (this.searchServiceId)
        serviceParams.filters.serviceId = this.searchServiceId
      if (this.searchServiceName)
        serviceParams.filters.serviceName = this.searchServiceName
      if (this.searchServiceType !== '')
        serviceParams.filters.serviceTypeKbn = this.searchServiceType
      if (this.searchStatus !== '')
        serviceParams.filters.serviceStatus = this.searchStatus
      if (this.searchTenant !== '')
        serviceParams.filters.tenantUuid = this.searchTenant
      if (this.searchCommunity !== '')
        serviceParams.filters.communityUuid = this.searchCommunity
      console.log('search.parameters', serviceParams)

      // データ読出し
      this.loadServiceList({
        serviceParams: serviceParams
      })
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
          this.tableData = $.extend(true, [], this.serviceModel)
        })
        .catch(error => {
          this.showError(error || null)
        })
    },

    // 絞り込み
    toggleFilters () {
      this.activeFilters = !this.activeFilters
    },
    changePerPage () {
      this.$refs.table.setLimit(this.filterPerPage)
    },

    detailItem (props) {
      this.$router.push({
        name: 'ServiceDetail',
        params: {
          serviceId: String(props.row.serviceUuid)
        }
      })
    }
  }
}